<script setup>
import {useDisplay} from "vuetify";
import {computed} from "vue";

const props = defineProps({
    banners: Array
})

const redirectLink = function (item) {
    const url = defaultUrl(item)

    if (url === '') {
        return '_self'
    }

    const urlObj = new URL(url);
    if (urlObj.host !== 'creativedesign.com.br') {
        return '_blank';
    } else {
        return '_self'
    }
}

const display = useDisplay()
const is1024 = computed(() => display.width.value <= 1024 && display.width.value > 960)

const hasUrl = function (item) {
    return item.url &&
        typeof item.url === 'string' &&
        item.url.trim() !== '';
}

const defaultUrl = function (item) {
    return hasUrl(item) ? item.url : '';
}
</script>

<template>
    <div class="banner-container">
        <v-carousel hide-delimiters cycle interval="10000" height="100%" :class="is1024 ? 'mt-16' : 'mt-0'">
            <v-sheet v-for="item in props.banners" :key="item">
                <a :href="defaultUrl(item)" :target="redirectLink(item)">
                    <v-carousel-item :src="item.banner_url" cover eager class="cursor-pointer"/>
                </a>
            </v-sheet>
        </v-carousel>
    </div>
</template>

<style scoped>
:deep(.v-btn--icon.v-btn--density-default) {
    background: transparent;
    box-shadow: none;
    font-size: 2rem;
}

@media (max-width: 1024px) {
    .banner-container{
        position: relative;
        top: -3.2rem;
        margin-bottom: -3.2rem;
    }
}

@media (max-width: 768px) {
    .banner-container{
        position: relative;
        top: 0;
        margin-bottom: 0;
    }
}
</style>